"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueVehicleValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class UniqueVehicleValidation extends journey_services_1.ValidationMethodBase {
    validateInput(input, context) {
        if (context && context.interaction && context.interaction.vehicles && input) {
            const inputToLowerCaseNoSpaces = input.toLowerCase().replace(/\s/g, "");
            let count = 0;
            if (context.interaction.vehicles.some((vehicle) => {
                if (vehicle.registrationNumber !== undefined && vehicle.registrationNumber.toLowerCase().replace(/\s/g, "") === inputToLowerCaseNoSpaces) {
                    count++;
                }
                return count > 1;
            })) {
                return this.invalidResult(this.getErrorMessage(context, "You have already added this vehicle"));
            }
        }
        return this.validResult();
    }
}
exports.UniqueVehicleValidation = UniqueVehicleValidation;
//# sourceMappingURL=UniqueVehicleValidation.js.map